import { lazy } from "react";
import { addHandleRoute, createRoute } from "../utils/RouteHelper";

// routes
export const transRoute = createRoute({
    path: "/transaction",
    name: "menu.whstrans",
    icon: "receipt_long",
    accCode: "transaksi_gudang",
    exclude_breadcrumbs: true,
});

export const transItemInRoute = createRoute({
    path: `${transRoute.path}/itemIn`,
    name: "trans_itemin.",
    accCode: "transaksi_gudang_barang_masuk",
    parentCode: transRoute.accCode,
});

export const transItemOutRoute = createRoute({
    path: `${transRoute.path}/itemOut`,
    name: "trans_itemout.",
    accCode: "transaksi_gudang_barang_keluar",
    parentCode: transRoute.accCode,
});

export const convertionRoute = createRoute({
    path: `${transRoute.path}/convertion`,
    name: "trans_convertion.",
    accCode: "transaksi_gudang_konversi",
    parentCode: transRoute.accCode,
});

export const stockOpnameRoute = createRoute({
    path: `${transRoute.path}/stockOpname`,
    name: "trans_stockopname.",
    accCode: "transaksi_gudang_stock_opname",
    parentCode: transRoute.accCode,
});

export const stockOpnameViewRoute = createRoute({
    path: `${stockOpnameRoute.path}/detail`,
    name: "trans_stockopname.detail",
    accCode: "transaksi_gudang_stock_opname",
    parentCode: transRoute.accCode,
});

export const stockOpnameCreateRoute = createRoute({
    path: `${stockOpnameRoute.path}/create`,
    name: "trans_stockopname.add",
    accCode: "transaksi_gudang_stock_opname",
    parentCode: transRoute.accCode,
    action: "create",
    redirectTo: stockOpnameRoute.path,
});

export const stockOpnameUpdateRoute = createRoute({
    path: `${stockOpnameRoute.path}/edit`,
    name: "trans_stockopname.edit",
    accCode: "transaksi_gudang_stock_opname",
    parentCode: transRoute.accCode,
    action: "edit",
    redirectTo: stockOpnameRoute.path,
});

export const transItemMoveRoute = createRoute({
    path: `${transRoute.path}/itemMove`,
    name: "trans_itemmove.",
    accCode: "transaksi_gudang_perpindahan_barang",
    parentCode: transRoute.accCode,
});

export const productionRoute = createRoute({
    path: `${transRoute.path}/production`,
    name: "trans_production.",
    accCode: "transaksi_gudang_proses_barang",
    parentCode: transRoute.accCode,
});

export const productionCreateRoute = createRoute({
    path: `${productionRoute.path}/create`,
    name: "trans_production.add",
    accCode: "transaksi_gudang_proses_barang",
    parentCode: transRoute.accCode,
    action: "create",
    redirectTo: productionRoute.path,
});

export const productionEditRoute = createRoute({
    path: `${productionRoute.path}/edit`,
    name: "trans_production.edit",
    accCode: "transaksi_gudang_proses_barang",
    parentCode: transRoute.accCode,
    action: "edit",
    redirectTo: productionRoute.path,
});

export const productionViewRoute = createRoute({
    path: `${productionRoute.path}/view`,
    name: "detail proses barang",
    accCode: "transaksi_gudang_proses_barang",
    parentCode: transRoute.accCode,
});

export const initStockRoute = createRoute({
    path: `${transRoute.path}/initStock`,
    name: "trans_initstock.",
    accCode: "transaksi_gudang_stock_awal",
    parentCode: transRoute.accCode,
});

export const itemInListRoute = createRoute({
    path: `${transRoute.path}/itemInList`,
    name: "trans_iteminlist.",
    accCode: "transaksi_gudang_supervisi_barang_masuk",
    parentCode: transRoute.accCode,
});

export const itemInListViewRoute = createRoute({
    path: `${itemInListRoute.path}/view`,
    name: "trans_iteminlist.detail",
    accCode: "transaksi_gudang_supervisi_barang_masuk",
    parentCode: transRoute.accCode,
});

export const itemOutListRoute = createRoute({
    path: `${transRoute.path}/itemOutList`,
    name: "trans_itemoutlist.",
    accCode: "transaksi_gudang_supervisi_barang_keluar",
    parentCode: transRoute.accCode,
});

export const itemOutListViewRoute = createRoute({
    path: `${itemOutListRoute.path}/view`,
    name: "trans_itemoutlist.detail",
    accCode: "transaksi_gudang_supervisi_barang_keluar",
    parentCode: transRoute.accCode,
});

export const returnCusListRoute = createRoute({
    path: `${transRoute.path}/returnCusList`,
    name: "trans_returncuslist.",
    accCode: "",
    parentCode: transRoute.accCode,
});

export const returnCusViewRoute = createRoute({
    path: `${returnCusListRoute.path}/view`,
    name: "trans_returncuslist.view",
    accCode: "transaksi_gudang_supervisi_retur_pelanggan",
    parentCode: transRoute.accCode,
});

export const returnCusPaymentRoute = createRoute({
    path: `${returnCusListRoute.path}/payment`,
    name: "trans_returncuslist.payment",
    accCode: "transaksi_gudang_supervisi_retur_pelanggan",
    parentCode: transRoute.accCode,
});

export const returnSupListRoute = createRoute({
    path: `${transRoute.path}/returnSupList`,
    name: "trans_returnsuplist.",
    accCode: "transaksi_gudang_supervisi_retur_pemasok",
    parentCode: transRoute.accCode,
});

export const returnSupViewRoute = createRoute({
    path: `${returnSupListRoute.path}/view`,
    name: "trans_returnsuplist.view",
    accCode: "transaksi_gudang_supervisi_retur_pemasok",
    parentCode: transRoute.accCode,
});

// component
const Transaction = lazy(() => import("../page/transaction/Transaction"));
const TransItemIn = lazy(() => import("../page/transaction/item_in/TransItemIn"));
const TransItemOut = lazy(() => import("../page/transaction/item_out/TransItemOut"));
const TransConversion = lazy(() => import("../page/transaction/conversion/TransConversion"));

const TransStockOpname = lazy(() => import("../page/transaction/stock_opname/TransStockOpname"));
const TransStockOpnameFrom = lazy(() => import("../page/transaction/stock_opname/form/TransStockOpnameForm"));
const TransStockOpnameView = lazy(() => import("../page/transaction/stock_opname/view/TransStockOpnameView"));

const TransItemMove = lazy(() => import("../page/transaction/item_move/TransItemMove"));

const TransProduction = lazy(() => import("../page/transaction/production/TransProduction"));
const TransProductionCreateForm = lazy(() => import("../page/transaction/production/form/TransProductionForm"));
const TransProductionEditForm = lazy(() => import("../page/transaction/production/form_edit/TransProductionFormEdit"));
const TransProductionView = lazy(() => import("../page/transaction/production/view/TransProductionView"));

const ItemInList = lazy(() => import("../page/transaction/list_item_in/TransItemInList"));
const ItemInListView = lazy(() => import("../page/transaction/list_item_in/view/TransItemInView"));

const ItemOutList = lazy(() => import("../page/transaction/list_item_out/TransItemOutList"));
const ItemOutListView = lazy(() => import("../page/transaction/list_item_out/view/TransItemOutView"));
const InitStock = lazy(() => import("../page/transaction/init_stock/InitStock"));

const ReturnCusList = lazy(() => import("../page/transaction/return_customer/ReturnCustomerList"))
const ReturnCusView = lazy(() => import("../page/transaction/return_customer/view/ReturnCustomerView"))
const ReturnCusPaymentForm = lazy(() => import("../page/transaction/return_customer/form_payment/ReturnCustomerFormPayment"))

const ReturnSupList = lazy(() => import("../page/transaction/return_supplier/ReturnSupplierList"))
const ReturnSupView = lazy(() => import("../page/transaction/return_supplier/view/ReturnSupplierView"))

export const transListRoutes = [
    transItemInRoute,
    transItemOutRoute,
    convertionRoute,
    stockOpnameRoute,
    transItemMoveRoute,
    productionRoute,
    initStockRoute,
    itemInListRoute,
    itemOutListRoute,
    returnCusListRoute,
    returnSupListRoute,
];

export const transMutationRoutes = [
    itemInListViewRoute, itemOutListViewRoute,
    stockOpnameCreateRoute, stockOpnameUpdateRoute,
    productionCreateRoute, productionEditRoute, productionViewRoute,
    returnCusViewRoute, returnCusPaymentRoute,
    returnSupViewRoute
];

export const transactionRoutes = {
    element: <Transaction />,
    children: addHandleRoute([
        { ...transItemInRoute, element: <TransItemIn /> },
        { ...transItemOutRoute, element: <TransItemOut /> },
        { ...convertionRoute, element: <TransConversion /> },
        { ...stockOpnameRoute, element: <TransStockOpname /> },
        { ...stockOpnameCreateRoute, element: <TransStockOpnameFrom type='add' /> },
        { ...stockOpnameUpdateRoute, element: <TransStockOpnameFrom type='edit' /> },
        { ...stockOpnameViewRoute, element: <TransStockOpnameView /> },
        { ...transItemMoveRoute, element: <TransItemMove /> },
        { ...productionRoute, element: <TransProduction /> },
        { ...productionCreateRoute, element: <TransProductionCreateForm /> },
        { ...productionEditRoute, element: <TransProductionEditForm /> },
        { ...productionViewRoute, element: <TransProductionView /> },
        { ...itemInListRoute, element: <ItemInList /> },
        { ...itemInListViewRoute, element: <ItemInListView /> },
        { ...itemOutListRoute, element: <ItemOutList /> },
        { ...itemOutListViewRoute, element: <ItemOutListView /> },
        { ...initStockRoute, element: <InitStock /> },
        { ...returnCusListRoute, element: <ReturnCusList /> },
        { ...returnCusViewRoute, element: <ReturnCusView /> },
        { ...returnCusPaymentRoute, element: <ReturnCusPaymentForm /> },
        { ...returnSupListRoute, element: <ReturnSupList /> },
        { ...returnSupViewRoute, element: <ReturnSupView /> },
    ]),
};